import { NestedCheckboxGroup } from "components/Form/components/CheckboxGroup/CheckboxGroupFormComponent";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import { getCheckedRecordValue } from "containers/AdvancedSearch/utils";
import { endedStatusArray, notEndedStatusArray } from "containers/ExecutionFilter/constants";
import { ValueLabelPair } from "containers/ExecutionFilter/interfaces";
import { useCallback, useMemo } from "react";

interface StatusFilterProps {
    input: InputComponentProps<string[]>;
    endedStatusList: ValueLabelPair[];
    notEndedStatusList: ValueLabelPair[];
    onStatusFilterChange: (value: string[]) => void;
    onChange: (newValues: string) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const StatusFilter = ({
    input,
    endedStatusList,
    notEndedStatusList,
    onStatusFilterChange,
    onChange,
}: StatusFilterProps) => {
    const currentValue = input?.value;

    const notEndedCheckboxState = getCheckedRecordValue(
        notEndedStatusArray,
        notEndedStatusArray.length,
        currentValue
    );

    const endedCheckboxState = getCheckedRecordValue(
        endedStatusArray,
        endedStatusArray.length,
        currentValue
    );

    const filterSelectedStatuses = useCallback(
        (arrayToExclude) => currentValue.filter((status) => !arrayToExclude.includes(status)),
        [currentValue]
    );

    const selectedNotEndedStatuses = useMemo(
        () => filterSelectedStatuses(endedStatusArray),
        [filterSelectedStatuses]
    );
    const selectedEndedStatuses = useMemo(
        () => filterSelectedStatuses(notEndedStatusArray),
        [filterSelectedStatuses]
    );

    const onAllEndedStatusesChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (endedCheckboxState) {
                onStatusFilterChange(selectedNotEndedStatuses);
            } else {
                onStatusFilterChange([...selectedNotEndedStatuses, ...endedStatusArray]);
            }
        },
        [endedCheckboxState, onStatusFilterChange, selectedNotEndedStatuses]
    );

    const onAllNotEndedStatusesChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (notEndedCheckboxState) {
                onStatusFilterChange(selectedEndedStatuses);
            } else {
                onStatusFilterChange([...selectedEndedStatuses, ...notEndedStatusArray]);
            }
        },
        [notEndedCheckboxState, onStatusFilterChange, selectedEndedStatuses]
    );
    return (
        <>
            <NestedCheckboxGroup
                mainLabel="Not ended"
                mainCheckboxValue={notEndedCheckboxState}
                onChangeAll={onAllNotEndedStatusesChange}
                identifier="not_ended"
                input={input}
                options={notEndedStatusList}
                onChange={onChange}
            />

            <NestedCheckboxGroup
                mainLabel="Ended"
                mainCheckboxValue={endedCheckboxState}
                onChangeAll={onAllEndedStatusesChange}
                identifier="ended"
                input={input}
                options={endedStatusList}
                onChange={onChange}
            />
        </>
    );
};
